import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHold3, SpinAndHold3Params } from "../SpinAndHold/SpinAndHold3";

export class ExtendedSpinAndHold3 extends SpinAndHold3 {
  protected override BonusName(): string {
    return "ExtendedSpinAndHold";
  }

  public constructor(gameResid: ResourceIdentifier, params: SpinAndHold3Params) {
    super(gameResid, params);
    }
}